// extracted by mini-css-extract-plugin
export var explainable = "_k2-a";
export var printerCard = "_k2-1";
export var printerCardConfigured = "_k2-2";
export var printerCardError = "_k2-3";
export var printerCardsContainer = "_k2-0";
export var printerIcon = "_k2-8";
export var printerIconConfigured = "_k2-5";
export var printerIconContainer = "_k2-4";
export var printerIconError = "_k2-6";
export var printerIconUnconfigured = "_k2-7";
export var workstationsTableCard = "_k2-9";